var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Prompt as RouterPrompt } from 'react-router-dom';

export var Prompt = function (_Component) {
  _inherits(Prompt, _Component);

  function Prompt() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Prompt);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Prompt.__proto__ || Object.getPrototypeOf(Prompt)).call.apply(_ref, [this].concat(args))), _this), _this.handleUnload = function () {
      if (!_this.props.when) {
        return false;
      }
      return _this.props.message; // eslint-disable-line no-alert
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Prompt, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Prompt.listeners.push(this.handleUnload);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      Prompt.listeners = Prompt.listeners.filter(function (listener) {
        return listener !== _this2.handleUnload;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(RouterPrompt, this.props);
    }
  }]);

  return Prompt;
}(Component);

Prompt.listeners = [];

Prompt.onUnload = function (event) {
  var message = void 0;
  for (var i = 0; i < Prompt.listeners.length; i += 1) {
    message = Prompt.listeners[i].apply(null, [event]);
    if (message && process.env.NODE_ENV !== 'development') {
      event.returnValue = message; // eslint-disable-line no-param-reassign
    }
  }
};

Prompt.propTypes = {
  message: PropTypes.string.isRequired,
  when: PropTypes.bool.isRequired
};

window.addEventListener('beforeunload', Prompt.onUnload);